import { render, staticRenderFns } from "./apply-record.vue?vue&type=template&id=9d50b66e&scoped=true&"
import script from "./apply-record.vue?vue&type=script&lang=js&"
export * from "./apply-record.vue?vue&type=script&lang=js&"
import style0 from "./apply-record.vue?vue&type=style&index=0&id=9d50b66e&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d50b66e",
  null
  
)

export default component.exports